import { format, formatDistanceToNow, isToday, isYesterday } from "date-fns";
import { AppointmentModel } from "../../calendar/models/AppointmentModel";
import { getStatusTextColorClass } from "ui/utils/statusColorMap";
import { ShiftHandoverAppointmentModel } from "../models/ShiftHandoverAppointmentModel";
export class ShiftHandoverTaskClass {
  id: number;
  appointmentId: number;
  typeFriendly: string;
  type: string;
  description: string;
  dueDateTime: { time: string; date: string };
  dueInfo: string;
  state: { color: string; value: string };
  starts_at: string;
  ends_at: string;
  status: string;
  preparationNeeded: boolean;

  private static formatDueDateTime = (inputDate: string | Date) => {
    const date = new Date(inputDate);
    const timeText = format(date, "hh:mm a");

    let dateText: string;
    if (isToday(date)) {
      dateText = "Today";
    } else if (isYesterday(date)) {
      dateText = "Yesterday";
    } else {
      dateText = format(date, "dd/MM/yyyy");
    }

    return { time: timeText, date: dateText };
  };

  private static formatDueRelativeTime = (inputDate: string | Date): string => {
    return formatDistanceToNow(new Date(inputDate), { addSuffix: true });
  };

  static fromAppointmentModel(
    item: AppointmentModel,
    friendlyNames: Record<string, string>,
  ): ShiftHandoverTaskClass {
    const taskData = new ShiftHandoverTaskClass();
    taskData.id = item.id;
    taskData.appointmentId = item.id;
    taskData.typeFriendly = friendlyNames[item.type] || item.type;
    taskData.type = item.type;
    taskData.description = item.title;
    taskData.dueDateTime = this.formatDueDateTime(item.starts_at);
    taskData.dueInfo = `Was due ${this.formatDueRelativeTime(item.starts_at)}`;
    taskData.state = {
      color: getStatusTextColorClass(item.status),
      value: item.status,
    };
    taskData.starts_at = item.starts_at;
    taskData.ends_at = item.ends_at;
    taskData.status = item.status;
    taskData.preparationNeeded = item.preparation_needed;

    return taskData;
  }

  static fromAppointmentModelsArray(
    item: AppointmentModel[],
    friendlyNames: Record<string, string>,
  ): ShiftHandoverTaskClass[] {
    return item.map((appointment) =>
      this.fromAppointmentModel(appointment, friendlyNames),
    );
  }

  static fromShiftHandoverAppointmentModel(
    item: ShiftHandoverAppointmentModel,
    friendlyNames: Record<string, string>,
  ): ShiftHandoverTaskClass {
    const taskData = new ShiftHandoverTaskClass();
    taskData.id = item.reportable_id ?? item.id;
    taskData.appointmentId = item.data.id;
    taskData.typeFriendly = friendlyNames[item.type] || item.type;
    taskData.type = item.type;
    taskData.description = item.description;
    taskData.dueDateTime = this.formatDueDateTime(item.due_to);
    taskData.dueInfo = `Due ${this.formatDueRelativeTime(item.due_to)}`;
    taskData.state = {
      color: getStatusTextColorClass(item.status),
      value: item.status,
    };
    taskData.starts_at = item.due_to;
    taskData.ends_at = item.data.ends_at;
    taskData.status = item.status;

    return taskData;
  }

  static fromShiftHandoverAppointmentModelsArray(
    item: ShiftHandoverAppointmentModel[],
    friendlyNames: Record<string, string>,
  ): ShiftHandoverTaskClass[] {
    return item.map((appointment) =>
      this.fromShiftHandoverAppointmentModel(appointment, friendlyNames),
    );
  }
}
